import React from 'react';

import { Link } from "react-router-dom";

import CircularProgress from '@mui/material/CircularProgress';

import ChartistGraph from "react-chartist";

import Icon from "@mui/material/Icon";
import MDAlert from '../components/MDAlert';
import MDTypography from "../components/MDTypography";

// @mui/icons-material
import Refresh from "@mui/icons-material/Refresh";

// core components
import Button from "../components/Button.jsx";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import OthelloGrid from '../componentsothello/OthelloGrid.jsx';
import OthelloCard from '../componentsothello/OthelloCard.jsx';
import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloTimer from '../componentsothello/OthelloTimer.jsx';
import OthelloTituloPanelData from '../componentsothello/OthelloTituloPanelData';

import { TipoOthelloFieldGrid, Roles, OpcionVisibilidadDashboard } from "../othelloConstantes.jsx";
import { getCurrentDataFormulario } from '../othelloFunciones.jsx';


var Chartist = require("chartist");
var delays = 80,
    durations = 500;
var delays2 = 80,
    durations2 = 500;

var straightLinesChart = {
    data: {
        labels: ["'07", "'08", "'09", "'10", "'11", "'12", "'13", "'14", "'15"],
        series: [[10, 16, 8, 13, 20, 15, 20, 34, 30]]
    },
    options: {
        lineSmooth: Chartist.Interpolation.cardinal({
            tension: 0
        }),
        low: 0,
        high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
        chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        },
        classNames: {
            point: "ct-point ct-white",
            line: "ct-line ct-white"
        }
    },
    animation: {
        draw: function (data) {
            if (data.type === "line" || data.type === "area") {
                data.element.animate({
                    d: {
                        begin: 600,
                        dur: 700,
                        from: data.path
                            .clone()
                            .scale(1, 0)
                            .translate(0, data.chartRect.height())
                            .stringify(),
                        to: data.path.clone().stringify(),
                        easing: Chartist.Svg.Easing.easeOutQuint
                    }
                });
            } else if (data.type === "point") {
                data.element.animate({
                    opacity: {
                        begin: (data.index + 1) * delays,
                        dur: durations,
                        from: 0,
                        to: 1,
                        easing: "ease"
                    }
                });
            }
        }
    }
};

var simpleBarChart = {
    data: {
        labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
    },
    options: {
        seriesBarDistance: 10,
        axisX: {
            showGrid: false
        }
    },
    responsiveOptions: [
        [
            "screen and (max-width: 640px)",
            {
                seriesBarDistance: 5,
                axisX: {
                    labelInterpolationFnc: function (value) {
                        return value[0];
                    }
                }
            }
        ]
    ],
    animation: {
        draw: function (data) {
            if (data.type === "bar") {
                data.element.animate({
                    opacity: {
                        begin: (data.index + 1) * delays2,
                        dur: durations2,
                        from: 0,
                        to: 1,
                        easing: "ease"
                    }
                });
            }
        }
    }
};

export default function DashboardMain({ ...props })
{
    const { literal, idRol } = props;


    const [loading, setLoading] = React.useState(false);
    const [dataIncidencias, setdataIncidencias] = React.useState(null);
    const [dataNotificaciones, setdataNotificaciones] = React.useState(null);
    const [dataanalitycs, setdataanalitycs] = React.useState(null);

    const [masfichas, setmasfichas] = React.useState(false);
    const [masareas, setmasareas] = React.useState(false);
    const [masimagenes, setmasimagenes] = React.useState(false);

    const [pendientesNotificar, setpendientesNotificar] = React.useState(-1);
    const [notificarHoy, setnotificarHoy] = React.useState(-1);

    const [franja, setfranja] = React.useState(30);    

    React.useEffect(() => {
        getDataPage(franja);
        setLoading(false);

    }, [loading]);


    const getDataPage = (dias) => {
        fetch('api/Data/GetDatosGlobalesOficina')
            .then(response => response.json())
            .then(data => {

                setpendientesNotificar(data.pendientesNotificar);
                setnotificarHoy(data.notificarHoy);
                setdataIncidencias(data.ultimasIncidencias);
                setdataNotificaciones(data.ultimasNotificaciones);

                getDatosAnalitycsOficina(dias);
            });
    }

    const getDatosAnalitycsOficina = (dias) =>
    {           
        let data = { dias: dias, desde: null, hasta: null}

        if (dias < 0) {
            let formulario = document.getElementById('formbusqueda');
            let datosFormulario = getCurrentDataFormulario(formulario);

            if (datosFormulario != null) {
                data.desde = datosFormulario.desde;
                data.hasta = datosFormulario.hasta;
            }
        }

        var jsonData = JSON.stringify(data);

        fetch('api/Data/GetDatosAnalitycsOficina', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(data => {
            setdataanalitycs(data);
            setmasfichas(false);
            setmasareas(false);
            setmasimagenes(false);
        }).catch(error => {

        });
    }



    const editGridDataPage = (valor, index) => {


    }

    /* METODOS A BORRAR*/


    const LoadingAgain = () => {
        setLoading(true);
        getDataPage(franja);
    }

    const MasFichas = () => {
        setmasfichas(!masfichas);
    }

    const MasAreas = () => {
        setmasareas(!masareas);
    }

    const MasImagenes = () => {
        setmasimagenes(!masimagenes);
    }

    const onChangeFranja = (valor) => {
        if (franja != valor) {
            setfranja(valor);
            getDataPage(valor);
        }
    }

    /* FIN METODOS A BORRAR*/

    //Metodo que monta los parametros de busqueda
    function MontarParametrosBusqueda() {

        return (<Grid container>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData margentop={1}>
                    <div>
                        <form id="formbusqueda" >
                            <Grid container xs={12}>
                                <div style={{ marginLeft: 15, marginTop: 5 }}>
                                <Button color='info' size="sm" onClick={LoadingAgain}><Refresh /> Refrescar Informacion</Button>
                            </div>
                            <Grid item xs={12} sm={2} >                                
                                <OthelloComboBox label='Franja' fieldname="franja" items={OpcionVisibilidadDashboard} currentvalue={franja != null ? franja : 30} onChange={onChangeFranja} />
                                </Grid>
                                <Grid item xs={6} sm={3} md={3} lg={1}>
                                    {franja != null && franja < 0 ? <OthelloTimer label="Desde" fieldname="desde" /> : ""}
                                </Grid>
                                <Grid item xs={6} sm={3} md={3} lg={1}>
                                    {franja != null && franja < 0 ? <OthelloTimer label="Hasta" fieldname="hasta" /> : ""}
                                </Grid>                                                    
                            </Grid>
                        </form>
                    </div>
                </OthelloTituloPanelData>
            </Grid>
        </Grid>)
    }

    function renderUltimasIncidenciasRecibidas(datos) {
        let valorescabe = ["Incidencia", "Tipo", "E-Mail", "Hora", "Latitud", "Longitud", "Descripcion"];

        //Generamos los valores de cada una de las lineas de grid       
        let valoreshow = ["nombre", "tipoInci", "eMail", "hora", "lat", "lon", "descripcion"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloDateTime, fieldname: "hora" });

        //Creamos el grid global 
        return (<OthelloGrid gridmode="simplecolor" datacabeceros={valorescabe} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} /*onEdit={editGridDataPage} */ />);
    }

    function renderUltimasNotificaciones(datos) {
        let valorescabe = ["Notificacion", "Notificado"];

        //Generamos los valores de cada una de las lineas de grid       
        let valoreshow = ["title", "notificado"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloDateTime, fieldname: "notificado" });

        //Creamos el grid global 
        return (<OthelloGrid gridmode="simplecolor" datacabeceros={valorescabe} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} /*onEdit={editGridDataPage} */ />);
    }

    function renderAnalitycs(datos) {

        let datosGlobales = <><Grid container mt={2}>
            <Grid item xs={12} sm={6} md={6} lg={3}>
                <OthelloCard color="info" categoria="Total Accesos" titulo={datos != null ? datos.numerototalaccesos : "-"} icono="people" footer="" iconofooter="date_range" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
                <OthelloCard color="info" categoria="Total Accesos Distintos" titulo={datos != null ? datos.numerototaldistintos : "-"} icono="verified_user" footer="" iconofooter="event" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
                <OthelloCard color="success" categoria="Total Accesos Android" titulo={datos != null ? datos.numerototalaccesosandroid : "-"} icono="android" footer="" iconofooter="event" />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
                <OthelloCard color="error" categoria="Total Accesos IOS" titulo={datos != null ? datos.numerototalaccesosIos : "-"} icono="desktop_mac" footer="" iconofooter="event" />
            </Grid>
        </Grid>
            <Grid container mt={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    <OthelloCard color="success" categoria="Total Cuentas Android" titulo={datos != null ? datos.totalcuentascreadasandroid : "-"} icono="android" footer="" iconofooter="date_range" />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    <OthelloCard color="error" categoria="Total Cuentas IOS" titulo={datos != null ? datos.totalcuentascreadasIos : "-"} icono="desktop_mac" footer="" iconofooter="event" />
                </Grid>
            </Grid>
            <Grid container mt={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    <OthelloCard color="warning" categoria="Acceso a Cupones" titulo={datos != null ? datos.accesocupones : "-"} icono="local_offer" footer="" iconofooter="date_range"  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    <OthelloCard color="warning" categoria="Cupones Canjeados" titulo={datos != null ? datos.cuponescanjeados : "-"} icono="local_offer" footer="" iconofooter="event" />
                </Grid>
            </Grid>
        </>

        //FICHAS VISITADAS
        let valorescabe = ["Nombre", "Dispositivo", "Total"];

        let valoreshow = ["nombre", "tipoDispositivo", "total"];

        let datasourceFields = [];

        let fichasVisitadasFinal = [];

        if (datos != null && datos.fichasvistas != null) {
            if (!masfichas && datos.fichasvistas.length > 10)
                fichasVisitadasFinal = datos.fichasvistas.slice(0, 9);
            else
                fichasVisitadasFinal = datos.fichasvistas;
        }

        let datosFichas = (<OthelloGrid gridmode="simplecolor" datacabeceros={valorescabe} datashow={valoreshow} datasource={fichasVisitadasFinal} datasourcefields={datasourceFields} /*onEdit={editGridDataPage} */ />);

        //IMAGENES VISITADAS
        let valorescabe2 = ["Nombre", "Dispositivo", "Total"];

        let valoreshow2 = ["nombre", "tipoDispositivo", "total"];

        let imagenesVisitadasFinal = [];

        if (datos != null && datos.imagenesvistas != null) {
            if (!masimagenes && datos.imagenesvistas.length > 10)
                imagenesVisitadasFinal = datos.imagenesvistas.slice(0, 9);
            else
                imagenesVisitadasFinal = datos.imagenesvistas;
        }

        let datosImagenes = (<OthelloGrid gridmode="simplecolor" datacabeceros={valorescabe2} datashow={valoreshow2} datasource={imagenesVisitadasFinal} datasourcefields={datasourceFields} /*onEdit={editGridDataPage} */ />);

        //AREAS VISITADAS
        let valorescabe3 = ["Nombre", "Dispositivo", "Total"];

        let valoreshow3 = ["nombre", "tipoDispositivo", "total"];

        let areasVisitadasFinal = [];

        if (datos != null && datos.areas != null) {
            if (!masareas && datos.areas.length > 10)
                areasVisitadasFinal = datos.areas.slice(0, 9);
            else
                areasVisitadasFinal = datos.areas;
        }

        let datosAreas = (<OthelloGrid gridmode="simplecolor" datacabeceros={valorescabe3} datashow={valoreshow3} datasource={areasVisitadasFinal} datasourcefields={datasourceFields} /*onEdit={editGridDataPage} */ />);

        return <>{datosGlobales}
            <Grid container mt={2}>
                <Grid item xs={12}>
                    <OthelloCard icono="article" titulo="Fichas Visitadas" color="info" smallmode={true} bigtitulo={false} >
                        <Grid container justify="space-between">
                            <Grid item xs={12} m={2}>
                                {datosFichas}
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container m={2}>
                            <Grid item xs={12} >
                                <Button size="sm" color="info" onClick={MasFichas}>{masfichas ? "Ver menos" : "Ver mas"}</Button>
                            </Grid>
                        </Grid>
                    </OthelloCard>
                </Grid>
            </Grid>
            <Grid container mt={2}>
                <Grid item xs={12}>
                    <OthelloCard icono="near_me" titulo="Areas Visitadas" color="success" smallmode={true} bigtitulo={false} >
                        <Grid container justify="space-between">
                            <Grid item xs={12} m={2} >
                                {datosAreas}
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container m={2}>
                            <Grid item xs={12} >
                                <Button size="sm" color="info" onClick={MasAreas}>{masareas ? "Ver menos" : "Ver mas"}</Button>
                            </Grid>
                        </Grid>
                    </OthelloCard>
                </Grid>
            </Grid>
            <Grid container mt={2}>
                <Grid item xs={12}>
                    <OthelloCard icono="image" titulo="Imagenes Visitadas" color="error" smallmode={true} bigtitulo={false} >
                        <Grid container justify="space-between">
                            <Grid item xs={12} m={2} >
                                {datosImagenes}
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container m={2}>
                            <Grid item xs={12} >
                                <Button size="sm" color="info" onClick={MasImagenes}>{masimagenes ? "Ver menos" : "Ver mas"}</Button>
                            </Grid>
                        </Grid>
                    </OthelloCard>
                </Grid>
            </Grid>
        </>
    }


    let incidencias = loading ? <p><CircularProgress color="secondary" /></p> : renderUltimasIncidenciasRecibidas(dataIncidencias);

    let notificaciones = loading ? <p><CircularProgress color="secondary" /></p> : renderUltimasNotificaciones(dataNotificaciones);

    let paramsbsuqueda = MontarParametrosBusqueda(this);
    //var date = new Date().getDate();
    //var month = new Date().getMonth() + 1;
    //var year = new Date().getFullYear();


    //let dia = date + '-' + month + '-' + year;

    let Analitycs = renderAnalitycs(dataanalitycs);
    
    return (
        <div>
            <Grid container>
                <Grid item xs={12} lg={12}>
                    <MDAlert color="success" sx={{ boxShadow: 3 }}>
                        <Icon fontSize="small">notifications_active</Icon>&nbsp;<MDTypography variant="button" color="white">{" "}ATMovilidad le da la bienvenida al nuevo gestor de contenidos.</MDTypography>
                    </MDAlert>
                </Grid>               
            </Grid>
            {idRol != Roles.Usuario ?
                <>
                    {paramsbsuqueda}
                    <Grid container mt={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <OthelloCard color="error" categoria="Pendientes de Notificar" titulo={pendientesNotificar} icono="notification_important" footer="A la espera de notificar los proximos dias (hoy incluido)" iconofooter="date_range" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <OthelloCard color="success" categoria="Pendientes de Notificar Hoy" titulo={notificarHoy} icono="notifications" footer="A la espera de notificar hoy" iconofooter="event" />
                        </Grid>
                    </Grid>
                    <Grid container container mt={2}>
                        <Grid item xs={12}>
                            <OthelloCard icono="notifications" titulo="Ultimas Notificaciones Realizadas" color="info" smallmode={true} bigtitulo={false} >
                                <Grid container justify="space-between" >
                                    <Grid item xs={12} m={2}>
                                        {notificaciones}
                                    </Grid>
                                </Grid>
                            </OthelloCard>
                        </Grid>
                    </Grid>
                    <Grid container container mt={2}>
                        <Grid item xs={12}>
                            <OthelloCard icono="how_to_vote" titulo="Ultimas Incidencias Recibidas" color="warning" smallmode={true} bigtitulo={false} vermas="/admin/incidencias">
                                <Grid container justify="space-between">
                                    <Grid item xs={12} m={2}>
                                        {incidencias}
                                    </Grid>
                                </Grid>
                            </OthelloCard>
                        </Grid>
                    </Grid>
                </> :
                <Grid container container mt={2}>
                    <Grid item xs={12} sm={12} md={12}>
                        <Card>
                            <div>
                                <b>Estamos trabajando para mostrale informacion personalizada sobre sus datos</b>
                            </div>
                        </Card>
                    </Grid>
                </Grid>}
            {Analitycs}
        </div>
    );
}


//<Grid container>
//    <Grid item xs={12} sm={12} md={6}>
//        <Card chart>
//            <div color="warning">
//                <ChartistGraph
//                    className="ct-chart-white-colors"
//                    data={straightLinesChart.data}
//                    type="Line"
//                    options={straightLinesChart.options}
//                    listener={straightLinesChart.animation}
//                />
//            </div>
//            <div>
//                <h4 className={classes.cardTitle}>Straight Lines Chart</h4>
//                <p className={classes.cardCategory}>Line Chart with Points</p>
//            </div>
//        </Card>
//    </Grid>
//    <Grid item xs={12} sm={12} md={6}>
//        <Card chart>
//            <div color="info">
//                <ChartistGraph
//                    className="ct-chart-white-colors"
//                    data={simpleBarChart.data}
//                    type="Bar"
//                    options={simpleBarChart.options}
//                    responsiveOptions={simpleBarChart.responsiveOptions}
//                    listener={simpleBarChart.animation}
//                />
//            </div>
//            <div>
//                <h4 className={classes.cardTitle}>Simple Bar Chart</h4>
//                <p className={classes.cardCategory}>Bar Chart</p>
//            </div>
//        </Card>
//    </Grid>
//</Grid>
